import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import FullCalendar from 'rc-calendar/lib/FullCalendar';
import Select from './../../wui-select/src/index.js';
import { WebUI } from "../../wui-core/src/index.js"; // moment.locale('zh-cn')

var propTypes = {};
var defaultProps = {}; // const format = 'YYYY-MM-DD';
// const cn = location.search.indexOf('cn') !== -1;
// const now = moment();
// if (cn) {
//     now.locale('zh-cn').utcOffset(8);
// } else {
//     now.locale('en-gb').utcOffset(0);
// }
// const defaultCalendarValue = now.clone();
// defaultCalendarValue.add(-1, 'month');

var Calendar = (_dec = WebUI({
  name: "calendar",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Calendar, _Component);

  var _super = _createSuper(Calendar);

  function Calendar() {
    _classCallCheck(this, Calendar);

    return _super.apply(this, arguments);
  }

  _createClass(Calendar, [{
    key: "onChange",
    value: // constructor(props, context) {
    //     super(props, context);
    //     this.state =  {
    //         type:'month',
    //     }
    // }
    // onTypeChange(type) {
    //     this.setState({
    //         type,
    //     });
    // }
    function onChange(value) {
      this.props.onChange && this.props.onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(FullCalendar, _extends({
        prefixCls: this.props.clsPrefix,
        Select: Select // defaultValue={now}
        // locale={zhCN}

      }, this.props, {
        onChange: this.onChange.bind(this)
      }));
    }
  }]);

  return Calendar;
}(Component)) || _class);
;
Calendar.propTypes = propTypes;
export default Calendar;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-calendar/src/Calendar.js